
























































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import debounce from "debounce";
import CourseLesson from "./UploadLessonCard.vue";
import SwitchLang from "./SwitchLanguageButton.vue";
import Button from "./Button.vue";
import { CourseCreationRequest, Course } from "../store/store.types";
import RichTextEditor from "./Forms/RichTextEditor.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { Action } from "vuex-class";
import { namespaced, NS_ADMIN } from "../store/namespace";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.full.esm";

// import { ValidationProvider, extend } from "vee-validate";
// import { required } from "vee-validate/dist/rules";
import {
  POST_COURSE,
  FETCH_COURSE,
  FETCH_PROGRAMMES,
  FETCH_COURSE_CATEGORIES,
} from "../store/actions.names";

const DEFAULT_COURSE_DATA: CourseCreationRequest = {
  name: "",
  name_en: "",
  name_bn: "",
  description: "",
  description_en: "",
  description_bn: "",
  estimated_time: "00:00:00",
  tags: [],
  type: "internal",
  external_link: "",
  pass_percentage: 40,
  invite_only: false,
  shared_with_ids: [],
  //  course_category_id: null
};

// extend("required", {
//   ...required,
//   message: "The {field} is required"
// });

@Component({
  name: "CourseEditor",
  components: {
    SwitchLang,
    Button,
    CourseLesson,
    // ValidationProvider,
    RichTextEditor,
    DurationPicker: VueTimepicker,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class CourseEditor extends Vue {
  public showUploadCard: boolean = false;
  @Prop({ default: null }) editData: null | Course;
  @Action(namespaced(NS_ADMIN, POST_COURSE)) postCourse: any;
  @Action(namespaced(NS_ADMIN, FETCH_COURSE)) fetchCourse: any;
  @Action(namespaced(NS_ADMIN, FETCH_PROGRAMMES)) searchProgrammes: any;
  @Action(namespaced(NS_ADMIN, FETCH_COURSE_CATEGORIES)) allCategories: any;
  lang: string = "bn";
  translations: any = {
    upload_course: {
      en: "Upload Course",
      bn: "কোর্স আপলোড",
    },
    edit_course: {
      en: "Edit Course",
      bn: "কোর্স এডিট",
    },
    cover_image: {
      en: "Cover Image",
      bn: "কাভারের ছবি",
    },
    photomsg: {
      en: "Choose a photo that represents your course.",
      bn: "আপনার কোর্স সম্পর্কিত একটি ছবি দিন।",
    },
    max_5mb: {
      en: "Max 5MB",
      bn: "সর্বোচ্চ ৫ মেগাবাইট",
    },
    upload_img: {
      en: "Upload Image",
      bn: "ছবি আপলোড",
    },
    description: {
      en: "Description",
      bn: "বিবরণ",
    },
  };
  get editMode() {
    return this.editData !== null;
  }

  duration = {
    HH: "00",
    mm: "10",
  };

  courseForm: CourseCreationRequest = JSON.parse(
    JSON.stringify(this.editData === null ? DEFAULT_COURSE_DATA : this.editData)
  );

  cancel() {
    this.$emit("cancel");
  }

  //search programmes
  selectedProgrammes = {};

  categoryData: any = null;
  // selectedCategory: any =
  selectedCategory: any = (this as any)?.editData?.course_category?.id || null;

  searchData = {
    searchTerm: "",
    programmes: [],
  };
  search = debounce((e) => {
    if (e.target.value.length != 0) {
      this.searchProgrammes(e.target.value).then((programmes) => {
        this.$set(this.searchData, "programmes", programmes);
        this.$set(this.searchData, "searchTearm", "");
      });
    } else {
      this.$set(this.searchData, "users", []);
    }
  }, 300);

  addProgramme(programme) {
    this.$set(this.selectedProgrammes, programme.id, programme.name);
    (this.$refs.searchInput as HTMLInputElement).value = "";
    this.$set(this.searchData, "programmes", []);
  }

  deletePrograme(key) {
    this.$delete(this.selectedProgrammes, key);
  }
  // search programmes

  uploadCourse() {
    let error: boolean = false;
    const data = JSON.parse(JSON.stringify(this.courseForm));
    delete data.published;
    let formData = null;
    data.name = data.name_bn;
    data.description = data.description_bn;
    data.estimated_time = `${this.duration.HH}:${this.duration.mm}:00`;
    delete data.published;
    delete data.cover_image;
    // // console.log(data);
    for (let key of ["name", "name_bn", "description", "description_bn"]) {
      if (data[key].length == 0) {
        error = true;
      }
    }
    if (
      ["internal", "linkedin"].indexOf(data["type"]) == -1 &&
      this.editMode == false
    ) {
      error = true;
    }
    if (data["invite_only"] == true) {
      data["shared_with_ids"] = Object.keys(this.selectedProgrammes).map((v) =>
        parseInt(v)
      );
    }
    if (
      data["type"] == "linkedin" &&
      data.external_link.length == 0 &&
      this.editMode == false
    ) {
      error = true;
    }
    if (
      (this.$refs["cover"] as HTMLInputElement).files.length == 0 &&
      this.editMode == false
    ) {
      error = true;
    }

    if (!error) {
      formData = new FormData();
      if (this.selectedCategory !== null) {
        formData.append(
          "course_category_id",
          parseInt(this.selectedCategory, 10)
        );
      } else {
        formData.append("course_category_id", "");
      }

      let cover = (this.$refs["cover"] as HTMLInputElement).files[0];
      // // console.log(typeof cover);
      if (typeof cover !== "undefined") {
        formData.append("cover_image", cover);
        // // console.log("appended");
      } else {
        delete data.cover_image;
      }
      Object.keys(data).map((key) => {
        if (key == "shared_with_ids") {
          data[key].forEach((item) => {
            formData.append(`shared_with_ids`, item);
          });
        } else if (key == "tags") {
          formData.append(key, JSON.stringify(data[key]));
        } else {
          formData.append(key, data[key]);
        }
      });
      let postData: any = {
        data: formData,
        edit: this.editMode,
      };
      if (this.editMode) {
        postData.slug = data.slug;
      }
      this.postCourse(postData)
        .then((data: any) => {
          // console.log(data);
          this.$emit("refresh", data.slug);
          // this.$router.push({
          //   name: "course-detail",
          //   params: { courseSlug: data.slug }
          // });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  mounted() {
    if (this.editMode) {
      this.courseForm["shared_with"].map((programme) => {
        this.$set(this.selectedProgrammes, programme.id, programme.name);
      });
    }
    this.allCategories()
      .then((data) => {
        this.categoryData = data;
        this.categoryData = [
          { id: null, name: "Select One" },
          ...this.categoryData,
        ];
      })
      .catch((e) => {
        // console.log(e);
      });
    console.log(this.selectedCategory);
  }
}
